import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseDialog from "../ui/BaseDialog";
import ActionButton from "../ui/ActionButton";

// modal to confirm whether to discard changes before closing
const UnsavedChangesModal = ({ open, onClose, onDiscard, darkMode }) => {
  const { t } = useTranslation();

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={t("Unsaved Changes")}
      darkMode={darkMode}
      ariaLabelledBy="unsaved-changes-modal-title"
      ariaDescribedBy="unsaved-changes-modal-description"
      actions={
        <>
          <ActionButton onClick={onClose} variant="default" modal>
            {t("Continue Editing")}
          </ActionButton>
          <ActionButton onClick={onDiscard} variant="danger" modal>
            {t("Exit Workspace")}
          </ActionButton>
        </>
      }
    >
      {/* message */}
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: "1rem",
          color: darkMode ? "#e0e0e0" : "#666666",
          textAlign: "center",
        }}
      >
        {t("You have unsaved changes. Are you sure you want to leave?")}
      </Typography>
    </BaseDialog>
  );
};

UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  darkMode: PropTypes.bool.isRequired,
};

export default UnsavedChangesModal;
